module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-2584c999!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/404.vue
// module id = 730
// module chunks = 2